﻿import { GuiDetailGeneric } from "../../GuiDetailGeneric";

export class GuiDetailBusinessunit extends GuiDetailGeneric {
    constructor() {
        super("Businessunit");

    }
}
